import React from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';

import { Countdown, DigitSlot } from '../styles';

/**
 * Contagem regressiva em que cada dígito rola ao mudar: o novo desce de cima
 * e empurra o anterior — só a casa que mudou se mexe.
 */
const CountdownDigits: React.FC<{ value: string }> = ({ value }) => {
  const reduce = useReducedMotion();
  const chars = value.split('');

  return (
    <Countdown role="timer" aria-label={value}>
      {chars.map((char, index) => (
        <DigitSlot
          // Casa contada da direita: ganhar a casa das horas não mexe nas outras.
          key={chars.length - index}
          data-sep={char === ':'}
          aria-hidden
        >
          <AnimatePresence initial={false}>
            <motion.span
              key={char}
              initial={reduce ? { opacity: 0 } : { y: '-100%', opacity: 0 }}
              animate={{ y: '0%', opacity: 1 }}
              exit={reduce ? { opacity: 0 } : { y: '100%', opacity: 0 }}
              transition={{ type: 'spring', bounce: 0.2, duration: 0.5 }}
            >
              {char}
            </motion.span>
          </AnimatePresence>
        </DigitSlot>
      ))}
    </Countdown>
  );
};

export default CountdownDigits;
